import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import { Tappable } from '@vectord/components';

import {
  AcademyProjectDetails,
  ACADEMY_PROJECT_MODAL_STAGES,
  academyProjectSelector,
  getAcademyProjectDetails,
  setAcademyProject,
  setAcademyProjectModalStage,
  useGetAcademyProjectQuery,
} from 'features/classCreation';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import Loader from 'components/Loader';
import SectionHeading from 'components/SectionHeading';

function AcademyProjectModalDetailsStage() {
  const dispatch = useDispatch();
  const academyProject = useSelector(academyProjectSelector);

  const { data, isLoading, error } = useGetAcademyProjectQuery(
    academyProject.id
  );

  const academyProjectDetails = getAcademyProjectDetails(data?.data);
  const { academyProjectId, academyProjectTestId, academyProjectTitle } =
    academyProjectDetails || {};

  const handleOnClick = useCallback(() => {
    batch(() => {
      dispatch(
        setAcademyProject({
          id: academyProjectId,
          title: academyProjectTitle,
          test_id: academyProjectTestId,
        })
      );
      dispatch(
        setAcademyProjectModalStage(ACADEMY_PROJECT_MODAL_STAGES.notOpen)
      );
    });
  }, [academyProjectId, academyProjectTitle, academyProjectTestId, dispatch]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
      dispatch(
        setAcademyProjectModalStage(ACADEMY_PROJECT_MODAL_STAGES.create)
      );
    }
  }, [error, dispatch]);

  if (isLoading) {
    return <Loader />;
  } else if (academyProjectDetails) {
    return (
      <>
        <SectionHeading
          title="CASE STUDY DETAILS"
          className="m-b-s"
        />
        <AcademyProjectDetails academyProjectDetails={academyProjectDetails} />
        <Tappable
          className="btn btn-primary m-t-s"
          onClick={handleOnClick}
        >
          Add Case Study
        </Tappable>
      </>
    );
  }
}

export default AcademyProjectModalDetailsStage;
